<button
  #btn
  mat-raised-button
  [color]="color()"
  [tabIndex]="tabDisabled() ? '-1' : '0'"
  [id]="id() ?? ''"
  [disabled]="isDisabled()"
  [style.--mdc-protected-button-container-color]="colorVars().container"
  [style.--mdc-protected-button-label-text-color]="colorVars().label"
  style="width: 100%"
  (click)="onClick($event)"
>
  @if (icon()) {
    <span class="material-symbols-outlined">{{ icon() }}</span>
  }
  {{ label() | siaTranslate }}
</button>
@if (enableDot()) {
  <span class="enable-dot"> </span>
}
